"use client";

import { useTranslations } from "use-intl";

import type { DealOffer } from "@/components/marketplace/deal-offers-types";
import { useAppDateTime } from "@/hooks/use-app-date-time";

/** "Updated 3 hours ago" freshness label for the hero offer panel header. */
export function DealOfferCheckedAt({ lastCheckedAt }: Pick<DealOffer, "lastCheckedAt">) {
  const t = useTranslations("shared.affiliates");
  const { recentTime } = useAppDateTime();
  const checkedAt = recentTime(lastCheckedAt);
  if (!checkedAt) return null;

  return (
    <span className="shrink-0 text-xs text-muted-foreground">
      {t(checkedAt.kind === "relative" ? "updatedRelative" : "updatedOn", {
        date: checkedAt.value,
      })}
    </span>
  );
}
